import { forEach, isFinite } from 'lodash';

import { OwnedObject, invalidateOwner, Magnitude } from 'gear';

import { Xml } from '../../util';

import { Figure } from '../figure';

import { Font } from './font';


let def = function(v,d) {
  return v != null ? v : d;
};
let defNum = function(v,d) {
  return isFinite(v) ? v : d;
};

export const TextProperties = Figure.TextProperties = OwnedObject.extend({ typeName: 'TextProperties', __debugProps: true,

  Properties : {
    font             : { type: 'Font'     , get() { return this._font; },
                       // [TODO] This shouldn't be needed, clients need to pass font objects
                         set( v ) { this._font = (v instanceof Font)? v.clone(): new Font(v); return this; },
                         owned: true, manualParsing: true, onChange: invalidateOwner },
    fontSize         : { type: 'magnitude', get() { return this._fontSize ;}, manualParsing: true, onChange: invalidateOwner },
    fontAutoSize     : { type: 'boolean'  , get() { return def(this._fontAutoSize     ,true     );}, manualParsing: true, onChange: invalidateOwner },
    lineDirection    : { type: 'number'   , get() { return defNum(this._lineDirection    ,0.0      );}, onChange: invalidateOwner },
    charDirection    : { type: 'number'   , get() { return defNum(this._charDirection    ,90.0     );}, onChange: invalidateOwner },
    extraCharSpacing : { type: 'magnitude', get() { return this._extraCharSpacing || new Magnitude(0.0,'mm');}, set( v ) { this._extraCharSpacing = v; }, manualParsing: true, onChange: invalidateOwner },
    extraWordSpacing : { type: 'magnitude', get() { return this._extraWordSpacing || new Magnitude(0.0,'mm');}, set( v ) { this._extraWordSpacing = v; }, manualParsing: true, onChange: invalidateOwner },
    extraLineSpacing : { type: 'magnitude', get() { return this._extraLineSpacing || new Magnitude(0.0,'mm');}, set( v ) { this._extraLineSpacing = v; }, manualParsing: true, onChange: invalidateOwner },
    columnSpacing    : { type: 'magnitude', get() { return this._columnSpacing    ;}, onChange: invalidateOwner },
    columnCount      : { type: 'integer'  , get() { return defNum(this._columnCount      ,1        );}, onChange: invalidateOwner },
    linesPerColumn   : { type: 'integer'  , get() { return defNum(this._linesPerColumn   ,0        );}, onChange: invalidateOwner },
    linesAlign       : { type: 'string'   , get() { return this._linesAlign || 'Center'  ;}, onChange: invalidateOwner },
    fillMode         : { type: 'string'   , get() { return this._fillMode   || 'Winding' ;}, onChange: invalidateOwner },
    powerClipId      : { type: 'string'   , get() { return this._powerClipId; }, onChange: invalidateOwner },
    verticalStyle    : { type: 'string'   , get() { return this._verticalStyle || 'SingleLine' ;}, onChange: invalidateOwner },
    perCharPolyregions : { type: 'boolean', get() { return def(this._perCharPolyregions,false); }, onChange: invalidateOwner }
  },

  init( c ) {
    this.callParent(c);
    if( ! c.font ) {
      this._font = Font.defaultFont();
    }
  },

  merge( defaults ) {
    const prop = {};
    //some stuff is not set on null here, we need to check against default values...
    forEach(this.Properties, (p,name) => {
      const m = p.member;
      prop[name] = def( this[m], defaults[m] );
    });
    if (prop.extraCharSpacing == 0) prop.extraCharSpacing = defaults.extraCharSpacing;
    if (prop.extraWordSpacing == 0) prop.extraWordSpacing = defaults.extraWordSpacing;
    if (prop.extraLineSpacing == 0) prop.extraLineSpacing = defaults.extraLineSpacing;
    if (prop.lineDirection == 0) prop.lineDirection = defaults.lineDirection;
    if (prop.charDirection == 90) prop.charDirection = defaults.charDirection;
    if (prop.columnCount == 1) prop.columnCount = defaults.columnCount;
    if (prop.linesPerColumn == 0) prop.linesPerColumn = defaults.linesPerColumn;
    if (prop.linesAlign == 'Center') prop.linesAlign = defaults.linesAlign;
    if (prop.fillMode == 'Winding') prop.fillMode = defaults.fillMode;
    if (prop.verticalStyle == 'SingleLine') prop.verticalStyle = defaults.verticalStyle;
    return new TextProperties(prop) ;
  },
  setupXml( node ) {
    // For the text properties we should not use defaults, because their presence means
    // that they should overwrite the parent value.
    Xml.setupProperties(node,this);
    const font = this._font, extraCharSpacing = this._extraCharSpacing,
        extraWordSpacing = this._extraWordSpacing, extraLineSpacing = this._extraLineSpacing,
        fontSize = this._fontSize, fontAutoSize = this._fontAutoSize;

    const { owner } = this;
    const fontNotNull             = font !== null,
        extraCharSpacingNotNull = extraCharSpacing !== null && extraCharSpacing != 0,
        extraWordSpacingNotNull = extraWordSpacing !== null && extraWordSpacing != 0,
        extraLineSpacingNotNull = extraLineSpacing !== null && extraLineSpacing != 0,
        fontSizeNotNull         = ( fontSize !== null || ( owner.isText && ! owner.isMultiPart ) ),
        fontAutoSizeNotNull     = fontAutoSize !== null;

    if( fontNotNull || extraCharSpacingNotNull || extraWordSpacingNotNull ||
        extraLineSpacingNotNull || fontSizeNotNull || fontAutoSizeNotNull ) {
      const fontNode = fontNotNull ? font.buildXml(node) : Xml.appendElement(node,'Font');

      if( fontAutoSizeNotNull ) {
        Xml.setBoolAttr(fontNode,'AutoSize',fontAutoSize);
      }

      if( extraCharSpacingNotNull ) {
        if (extraCharSpacing instanceof Magnitude) 
          fontNode.setAttribute('ExtraCharSpacing',extraCharSpacing.toString());
        else                        
          fontNode.setAttribute('ExtraCharSpacing',(new Magnitude(extraCharSpacing,'mm')).toString());  
      }

      if( extraLineSpacingNotNull ) {
        if (extraLineSpacing instanceof Magnitude) 
          fontNode.setAttribute('ExtraLineSpacing',extraLineSpacing.toString());
        else                        
          fontNode.setAttribute('ExtraLineSpacing',(new Magnitude(extraLineSpacing,'mm')).toString());  
      }

      if( extraWordSpacingNotNull ) {
        if (extraWordSpacing instanceof Magnitude) 
          fontNode.setAttribute('ExtraWordSpacing',extraWordSpacing.toString());
        else                        
          fontNode.setAttribute('ExtraWordSpacing',(new Magnitude(extraWordSpacing,'mm')).toString());  
      }
      // Get default value, to force encoding for single part text
      if( fontSizeNotNull ) {
        if (fontSize instanceof Magnitude) 
          fontNode.setAttribute('Size',fontSize.toString()); 
        else                        
          fontNode.setAttribute('Size',(new Magnitude(fontSize,'mm')).toString());  
      }
    }
  }
});

TextProperties.parseXml = function( node ) {
  const p = Xml.parseProperties(node,TextProperties);
  p.font = Font.fromXml(node);
  const fontNode = Xml.child(node,'Font');
  if(fontNode) {
    p.fontSize = Magnitude.parse(fontNode.getAttribute('Size')) || new Magnitude(54.2,'mm'); // Magnitude
    p.fontAutoSize = Xml. getBoolAttr(fontNode, 'AutoSize',null);

    p.extraCharSpacing = Magnitude.parse(fontNode.getAttribute('ExtraCharSpacing')); // Magnitude
    if( p.extraCharSpacing === null ) {
      p.extraCharSpacing = Magnitude.parse(fontNode.getAttribute('Spacing')) || new Magnitude(0.0,'mm'); // Magnitude
    }

    p.extraWordSpacing = Magnitude.parse(fontNode.getAttribute('ExtraWordSpacing')) || new Magnitude(0.0,'mm'); // Magnitude

    p.extraLineSpacing = Magnitude.parse(fontNode.getAttribute('ExtraLineSpacing')); // Magnitude
    if( p.extraLineSpacing === null ) {
      p.extraLineSpacing = Magnitude.parse(fontNode.getAttribute('LineSpacing')) || new Magnitude(0.0,'mm'); // Magnitude
    }
  }
  return new TextProperties(p);
};



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/text/properties.js
 **/